"use strict";
/*
    Express.Session is a global interface defined by express-session, we need to pull it in manually
    for our Cypress tsconfig
*/
// <reference types="express-session" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_ACCOUNT_HEADER = exports.STAFF_CONTEXT_HEADER = exports.USER_CONTEXT_HEADER = exports.VALID_MECHANISMS = exports.SlauthMechanism = exports.SlauthHeader = exports.UserRedirectionType = exports.UserIssuer = void 0;
var UserIssuer;
(function (UserIssuer) {
    UserIssuer["PARTNER_CENTRAL"] = "partner_central";
})(UserIssuer = exports.UserIssuer || (exports.UserIssuer = {}));
var UserRedirectionType;
(function (UserRedirectionType) {
    UserRedirectionType["CASSI"] = "CASSI";
    UserRedirectionType["ADA"] = "ADA";
    UserRedirectionType["SALESFORCE"] = "Salesforce";
    UserRedirectionType["GSAC"] = "GSAC";
    UserRedirectionType["SSAM"] = "SSAM";
    UserRedirectionType["LightningSalesforce"] = "LightningSalesforce";
    UserRedirectionType["FinOpsLink"] = "FinOpsLink";
})(UserRedirectionType = exports.UserRedirectionType || (exports.UserRedirectionType = {}));
var SlauthHeader;
(function (SlauthHeader) {
    SlauthHeader["MECHANISM"] = "X-Slauth-Mechanism";
    SlauthHeader["SUBJECT"] = "X-Slauth-Subject";
    SlauthHeader["ISSUER"] = "X-Slauth-Issuer";
    SlauthHeader["PRINCIPAL"] = "X-Slauth-Principal";
    SlauthHeader["ACCOUNT_ID"] = "x-slauth-user-context-account-id";
    SlauthHeader["FORWARDED_PREFIX"] = "x-forwarded-prefix";
    SlauthHeader["CLAIMS"] = "X-Slauth-Claims";
})(SlauthHeader = exports.SlauthHeader || (exports.SlauthHeader = {}));
var SlauthMechanism;
(function (SlauthMechanism) {
    SlauthMechanism["ASAP"] = "asap";
    SlauthMechanism["SAML"] = "saml";
    SlauthMechanism["BYPASS"] = "bypass";
    SlauthMechanism["COOKIE"] = "cookie";
})(SlauthMechanism = exports.SlauthMechanism || (exports.SlauthMechanism = {}));
exports.VALID_MECHANISMS = [
    SlauthMechanism.ASAP,
    SlauthMechanism.SAML,
    SlauthMechanism.COOKIE,
    SlauthMechanism.BYPASS,
];
exports.USER_CONTEXT_HEADER = 'user-context';
exports.STAFF_CONTEXT_HEADER = 'staff-context';
exports.TRANSACTION_ACCOUNT_HEADER = 'x-transaction-account';
